import { throttle } from 'lodash';

function getClosestSectionToCenter(sections) {
	const viewportCenter = window.innerHeight / 3;
	let closestSection = null;
	let smallestDistance = Infinity;
	// let div = document.createElement('div');
	// div.style.border = '2px solid green';
	// div.style.position = 'fixed';
	// div.style.width = '100%';
	// div.style.top = viewportCenter + 'px';
	// div.style.zIndex = '9999';
	// document.body.appendChild(div);
	sections.forEach(section => {
		// section.style.border = 'none';
		const rect = section.getBoundingClientRect();
		const sectionCenter = rect.top + rect.height / 3;
		const distanceToCenter = Math.abs(sectionCenter - viewportCenter);
		if (distanceToCenter < smallestDistance && rect.height) {
			smallestDistance = distanceToCenter;
			closestSection = section;
		}
	});
	if (closestSection) {
		// closestSection.style.background = 'red';
	}
	// 计算元素的中心位置
	return closestSection;
}

//  滚动监听
export const initObserver = (sections, callback) => {
	if (!sections) {
		return;
	}
	let throttleFn = throttle(() => {
		const closestSection = getClosestSectionToCenter(sections);
		if (closestSection) {
			const sectionId = closestSection.id;
			callback('in', sectionId);
		} else {
		}
		// sections.forEach(entry => {
		// 	const entryProps = entry.getBoundingClientRect();
		// 	const sectionId = entry.id;
		// 	const viewportCenter = window.innerHeight / 2;
		// 	if (entryProps.top <= viewportCenter && entryProps.bottom >= viewportCenter) {
		// 		callback('in', sectionId);
		// 	}
		// });
	}, 50);
	window.addEventListener('scroll', throttleFn);
	let remover = () => {
		window.removeEventListener('scroll', throttleFn);
	};
	return remover;
};
